import {
  DataTable as MDataTable,
  type DataTableColumn,
  type DataTableProps as MantineDataTableProps,
} from 'mantine-datatable';
import classes from './data-table.module.scss';
import { EmptyRowsFallback, PAGE_SIZES } from '@shared/ui/DataTable';

type DataTableProps<R> = {
  fetching: boolean;
  columns: DataTableColumn<R>[];
  records: R[];
  page?: number;
  setPage?: (page: number) => void;
  pageSize?: number;
  setPageSize?: (pageSize: number) => void;
  emptyState?: React.ReactNode;
  onRowClick?: (params: {
    record: R;
    index: number;
    event: React.MouseEvent;
  }) => void;
  totalRecords?: number;
} & Omit<MantineDataTableProps<R>, 'onRowClick'>;

export const DataTable = <R,>({
  fetching,
  columns,
  records,
  page,
  setPage,
  pageSize,
  setPageSize,
  emptyState = <EmptyRowsFallback />,
  onRowClick,
  totalRecords,
  recordsPerPageOptions = PAGE_SIZES,
  onRecordsPerPageChange,
  height = 'auto',
  ...props
}: DataTableProps<R>) => {
  const handlerPerPageSize = (p: number) => {
    setPage && setPage(1);
    setPageSize && setPageSize(p);
  };

  return (
    <MDataTable<R>
      {...props}
      minHeight={220}
      height={height}
      columns={columns}
      records={records}
      classNames={classes}
      rowClassName={classes.row}
      verticalSpacing='0.375rem'
      horizontalSpacing='1rem'
      scrollAreaProps={{
        // Todo-Omarov, помогает стилизовать скролл, но отсутсвует в типизации scrollAreaProps
        // @ts-ignore
        styles: {
          thumb: {
            zIndex: 20,
          },
        },
      }}
      emptyState={emptyState}
      totalRecords={totalRecords || records?.length}
      recordsPerPage={pageSize}
      page={page}
      onPageChange={setPage ? p => setPage(p) : undefined}
      recordsPerPageOptions={recordsPerPageOptions}
      onRecordsPerPageChange={onRecordsPerPageChange ?? handlerPerPageSize}
      recordsPerPageLabel=''
      fetching={fetching}
      noRecordsText=''
      onRowClick={onRowClick}
    />
  );
};
